import script from "./MemberSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberSettings.vue?vue&type=script&setup=true&lang=js"

import "./MemberSettings.vue?vue&type=style&index=0&id=0f53cc70&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f53cc70"]])

export default __exports__